const encodeQueryParams = params => {
  const result = [];

  for (const param in params) {
    result.push(`${encodeURIComponent(param)}=${encodeURIComponent(params[param])}`);
  }

  return result.join('&');
}

export default encodeQueryParams;